import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sourceFile: null,
  targetFormat: 'png',
  outputUrl: null,
  isConverting: false,
  error: null,
}

const imageConverterSlice = createSlice({
  name: 'imageConverter',
  initialState,
  reducers: {
    setSourceFile: (state, action) => {
      state.sourceFile = action.payload
      state.outputUrl = null
      state.error = null
    },
    setTargetFormat: (state, action) => {
      state.targetFormat = action.payload
    },
    setConverting: (state, action) => {
      state.isConverting = action.payload
    },
    setOutputUrl: (state, action) => {
      state.outputUrl = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.isConverting = false
    },
    clearConverterState: (state) => {
      state.sourceFile = null
      state.outputUrl = null
      state.isConverting = false
      state.error = null
    },
  },
})

export const {
  setSourceFile,
  setTargetFormat,
  setConverting,
  setOutputUrl,
  setError,
  clearConverterState,
} = imageConverterSlice.actions

export default imageConverterSlice.reducer
